// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"dadae60a","239":"a2d85800","453":"ca7e61f3","455":"1e7cbe1f"}[chunkId] + ".chunk.js";
};